<template>
     <div>
        <v-combobox
            class="counterpart"
            :key="myKey"
            :value="myValue"
            :readonly="readonly"
            :items="items"
            @keydown="handleKeyDown"
            @input.native="myNativeInput"
            autocomplete="off"
            item-text="account"
            item-value="account"
            @input="handleInput"
            @change="myChange"
            @click="myClick"
            @blur="myBlur"
            append-icon=""
            :autofocus="autofocus"
            hide-details
            solo
            dense
            flat
            :class="right_input ? 'right-input mr-1' : ''"
        ><template slot="item" slot-scope="data">
          {{ data.item.account }} - {{ data.item.description }} <template v-if="show_balance"> - ({{ roundBalance(data.item.balance) }} €)</template> 
          </template>
        </v-combobox>
    </div>
  </template>
  
  <script>
  export default {
    name: 'ContrapartidaField',
    props: {
      value:[String, Number, Array, Boolean, Object],
      num_digits: {
        type: [Number],
        default: 8
      },
      required: { 
        type: Boolean,
        default: false
      },
      readonly: { 
        type: Boolean,
        default: false
      },
      items: {
        type: Array,
        default: () => []
      },
      show_balance: {
        type: Boolean,
        default: true
      },
      autofocus: {
        type: Boolean,
        default: false
      },
      right_input: {type:Boolean, default: false},
    },
    data() {
        return {
          myValue: undefined,
          myKey: 0,
        };
    },
    created() {
        this.myValue = this.value;
    },
    methods: {
        handleInput(val) {
            if (typeof val === 'object') {
              this.myValue = val.account;
            } else {
              this.myValue = val;
            }
            this.$emit('input', this.myValue);
        },
        handleKeyDown(e) {
            if (e.ctrlKey) return
            switch(e.keyCode) {
            case 13:
                this.enterPressed()
                break
            default:
                break
            }
        },
        myNativeInput(value) {
            this.myValue=value.target.value
            let params = {'text': value.target.value};
            this.$emit('get-values', params);
            this.$emit('input', value.target.value);
        },
        enterPressed() {
            this.fillAccount()
        },
        fillAccount(){
          let targetLength=this.num_digits
          if((this.myValue.toString().match(/\./g) || []).length==1 && 
              this.myValue.length<=targetLength
              ){
              let pos=this.myValue.indexOf('.')
              let left=this.myValue.substring(0,pos)
              let right=this.myValue.substring(pos+1)
              const newValue = left + '0'.repeat(targetLength - this.myValue.length + 1) + right;
              this.myValue = newValue;
              this.myKey++
              
              }
          this.$emit('input', this.myValue);
          this.$emit('change', this.myValue);
        },
        myChange(val){
          if (typeof val === 'object') {
            this.myValue = val.account;
          } else {
            this.myValue = val;
          }
          this.$emit('change', this.myValue);
        },
        myClick(){
          let params = {'text': this.value};
          this.$emit('get-values', params);
        },
        myBlur() {
            this.$emit('reset-items', []);
        },
        roundBalance(num) {
          return Number(num.toFixed(2))
        }
      
    },
    watch:{
        value(newVal, oldVal) {
            this.myValue = newVal;
        }
    }
  };
  </script>

<style scoped>

.counterpart >>> .v-input__control>.v-input__slot {
  background: none !important;
  padding: 0px !important;
  margin: 0px !important;
}

.right-input >>> input {
  text-align: right;
}
</style>